<template>
    <div id="Doc">
        <b-container>
                <div v-html="text"></div>
        </b-container>
        <b-container fluid class="footer text-center">
        </b-container>
    </div>
</template>

<script>
import { BContainer } from 'bootstrap-vue';

export default {
  name: 'Doc',
  components: {
    BContainer
  },
  data: function() {
    return {
      title: '',
      text: '',
      accept: false,
      intLoc: this.$i18n.locale
    }
  },
  mounted() {
    this.title = this.$route.params.title;
    this.accept = this.$store.state.accept;
    this.getDoc();
  },
  methods: {
    async getDoc() {
        try {
            const response = await this.$http.get('/getDoc', {
                params: {
                    title: this.title,
                    locale: this.intLoc
                }
            });
            this.text = response.data;
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    }
  },
  watch: {
    '$store.state.intLoc': function() {
        this.intLoc = this.$store.state.intLoc;
        this.getDoc();
    }
  }
}

</script>

<style>
</style>